const MediaItemClassName = {
  PHOTO: "Photo",
  VIRTUAL_TOUR: "VirtualTour",
  VIDEO_CLIP: "VideoClip",
};

export default MediaItemClassName;
